import React, { Fragment, Component } from "react";
import { withRouter } from "react-router";
import {
  Card,
  CardBody,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Spinner,
} from "reactstrap";
import classnames from "classnames";
import IndexBloc from "./Blocs/IndexBloc";
import Select from "react-select";
import apiResponse from "../../../../services/apiResponse";
import IndexComponent from "./Components/IndexComponent";
import { Alert } from "reactstrap";
import "./style.scss";

class IndexView extends Component {
  indexBloc = new IndexBloc();

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      detail: null,
      blinkAlerts: true,
      currentAlertIndex: 0,
      listNameHost: [],
      activeTab: "1",
      selectedHost: null,
      isLoading: true,
    };

    this.activeRef = React.createRef();
    this.inactiveRef = React.createRef();
  }

  reloadActiveRef = () => this.activeRef.current.setTokenAPI();
  reloadInactiveRef = () => this.inactiveRef.current.setTokenAPI();

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  }

  handleServerChange = (selectedOption) => {
    this.setState({ selectedHost: selectedOption });
  };

  convertToBytes(valueWithUnit) {
    const [value, unit] = valueWithUnit.split(" ");
    const numericValue = parseFloat(value);

    switch (unit) {
      case "KB":
        return numericValue * 1e3;
      case "MB":
        return numericValue * 1e6;
      case "GB":
        return numericValue * 1e9;
      case "TB":
        return numericValue * 1e12;
      case "B":
      case undefined:
        return numericValue;
      default:
        throw new Error(`Unknown unit: ${unit}`);
    }
  }

  convert(valueInBytes) {
    if (valueInBytes >= 1e12) {
      return `${(valueInBytes / 1e12).toFixed(2)} TB`;
    } else if (valueInBytes >= 1e9) {
      return `${(valueInBytes / 1e9).toFixed(2)} GB`;
    } else if (valueInBytes >= 1e6) {
      return `${(valueInBytes / 1e6).toFixed(2)} MB`;
    } else if (valueInBytes >= 1e3) {
      return `${(valueInBytes / 1e3).toFixed(2)} KB`;
    } else {
      return `${valueInBytes.toFixed(2)} Bytes`;
    }
  }

  componentDidMount() {
    this.indexBloc.getallHostChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;
          const hostOptions = response.map((item) => ({
            value: item.hostid,
            label: item.name,
          }));

          // const defaultHost = hostOptions.find(
          //   (option) => option.label === "server-rancher-master"
          // );
          const defaultHost = hostOptions.length > 0 ? hostOptions[0] : null;

          this.setState({
            listNameHost: hostOptions,
            selectedHost: defaultHost || null,
            isLoading: false,
          });
          break;
        case apiResponse.ERROR:
          this.setState({ isLoading: false });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchAllHosts({});

    this.indexBloc.getAllSpaceUtilizationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          let response = result.data.response;

          this.setState({
            data: response,
            loading: false,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.fetchAllGraphSpaceUtilizationAll({});
  }

  alert() {
    const { data } = this.state;
    if (!data || data.length === 0) {
      return [];
    }
    return data
      .map((host) => {
        const graphs = host.graphs || [];

        return graphs
          .map((graph) => {
            const items = graph.items || [];
            let usedSpace = null;
            let totalSpace = null;

            items.forEach((item) => {
              if (item.name.includes("Used space")) {
                usedSpace = this.convertToBytes(item.last);
              }
              if (item.name.includes("Total space")) {
                totalSpace = this.convertToBytes(item.last);
              }
            });

            if (usedSpace !== null && totalSpace !== null) {
              const remainingPercentage =
                ((totalSpace - usedSpace) / totalSpace) * 100;

              if (remainingPercentage <= 15) {
                return {
                  hostName: host.name,
                  hostId: host.hostid,
                  graphName: graph.name,
                  usedSpace,
                  totalSpace,
                  remainingPercentage: remainingPercentage.toFixed(2),
                  useSpaceConvert: this.convert(usedSpace),
                  totalSpaceConvert: this.convert(totalSpace),
                };
              }
            }

            return null;
          })
          .filter(Boolean);
      })
      .flat();
  }

  render() {
    const { isLoading } = this.state;

    const renderTableView = () => {
      const alerts = this.alert();
      return (
        <>
          {alerts.map((alert, index) => (
            <Alert
              key={index}
              className={this.state.blinkAlerts ? "blink" : ""}
              color="danger"
            >
              <span className="uil-exclamation-triangle"> Host:</span>
              <strong> {alert.hostName}</strong> Disk:{" "}
              <strong>{alert.graphName}</strong>. Available space:{" "}
              <strong>{alert.totalSpaceConvert}</strong>. Used space:{" "}
              <strong>{alert.useSpaceConvert}</strong>.
            </Alert>
          ))}
          <Nav tabs>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggle("1");
                }}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-home"></i>
                </span>
                <span className="d-none d-sm-block">
                  <span className="uil-cloud-block"></span> Grafik Total
                  Penyimpanan Disk
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent
            activeTab={this.state.activeTab}
            className="p-3 text-muted"
          >
            <TabPane tabId="1">
              <IndexComponent
                ref={this.activeRef}
                handleInactiveSuccess={this.reloadInactiveRef}
                selectedHost={this.state.selectedHost}
              />
            </TabPane>
          </TabContent>
        </>
      );
    };

    const renderView = () => {
      if (isLoading) {
        return (
          <div className="text-center">
            <div>
              <Spinner
                style={{ width: "3rem", height: "3rem", borderWidth: "0.4rem" }}
                color="dark"
              />
            </div>
            <div>
              <span style={{ fontWeight: "bold" }}>Mengambil Data ...</span>
            </div>
          </div>
        );
      } else {
        return renderTableView();
      }
    };
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Alert color="info">
                    <CardTitle>File Sistem</CardTitle>
                    <CardSubtitle>
                      Memantau ruang penyimpanan yang tersedia dan digunakan
                      pada sistem, memastikan bahwa kapasitas penyimpanan
                      dikelola dengan efisien dan mencegah potensi masalah
                      terkait ruang disk yang terbatas.
                    </CardSubtitle>
                  </Alert>
                  <hr />
                  <Row>
                    <Col md="3">
                      <label>Pilih Host : </label>
                      <br />
                      <Select
                        options={this.state.listNameHost}
                        placeholder="Pilih Host"
                        onChange={this.handleServerChange}
                        value={this.state.selectedHost}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Card>
                      <CardBody>{renderView()}</CardBody>
                    </Card>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

export default withRouter(IndexView);
